import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";

/* 
    Exportando diretamente para manter a assinatura. 
    Desta maneira ListItem aplica a classe necessária para não sobrepror o evento
*/
export default ListItemSecondaryAction;
